<app-exam-header [pageTitle]="'Mindset Shift'"></app-exam-header>

<section class="hero-section">
  <div class="container">
    <div class="hero-content">
      <div class="left-column">
        <div class="book-cover-container">
          <img
            [src]="siteUrl + 'api/static/' + bookCover"
            alt="Mindset Shift Book Cover"
            class="book-cover-image"
            *ngIf="bookCover"
          />
          <div class="book-cover-placeholder" *ngIf="!bookCover">
            <span>Mindset Shift</span>
          </div>
        </div>
      </div>

      <div class="right-column">
        <div class="book-title-container">
          <div class="title-author-wrapper">
            <div class="title-accent-line"></div>
            <h1 class="main-headline">
              <span class="highlight-text">Mindset</span> Shift
            </h1>
            <div class="author-info">
              <div class="author-details">
                <p class="author">By Sharani Ponguru</p>
                <p class="author-title">Founder – The Mindset Movement</p>
              </div>
            </div>
          </div>
          <h2 class="sub-headline">
            Small Changes, <span class="highlight-impact">Big Impact</span>
          </h2>
          <p class="emotional-hook">
            The book that's quietly transforming lives. Now it's your turn.
          </p>
        </div>

        <div class="hero-info">
          <h3 class="core-promise">
            Heal Your Mind. Align Your Emotions. Shift Your Life.
          </h3>

          <p class="description">
            For Students, Parents, Professionals, and seekers Ready to Feel
            Aligned Again, learn to shift from chaos to clarity using The
            Mindset Shift Methodology, which is rooted in simplicity, science,
            and soul.
          </p>

          <div class="rating-section">
            <div class="rating-card">
              <div class="rating-icon-wrapper">
                <span class="rating-icon">★★★★★</span>
                <div class="rating-glow"></div>
              </div>
              <div class="rating-content">
                <span class="rating-value">4.9</span>
                <span class="rating-text">out of 5 stars</span>
              </div>
            </div>

            <div class="divider"></div>

            <div class="students-card">
              <div class="students-icon-wrapper">
                <span class="students-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 7C16 9.21 14.21 11 12 11C9.79 11 8 9.21 8 7C8 4.79 9.79 3 12 3C14.21 3 16 4.79 16 7Z"
                      fill="#FFCC00"
                    />
                    <path
                      d="M12 14C8.13 14 5 17.13 5 21H19C19 17.13 15.87 14 12 14Z"
                      fill="#FFCC00"
                    />
                    <path
                      d="M21 12C21 13.1 20.1 14 19 14C17.9 14 17 13.1 17 12C17 10.9 17.9 10 19 10C20.1 10 21 10.9 21 12Z"
                      fill="#FFCC00"
                      fill-opacity="0.6"
                    />
                    <path
                      d="M19 15C17.34 15 16 16.34 16 18H22C22 16.34 20.66 15 19 15Z"
                      fill="#FFCC00"
                      fill-opacity="0.6"
                    />
                    <path
                      d="M7 12C7 13.1 6.1 14 5 14C3.9 14 3 13.1 3 12C3 10.9 3.9 10 5 10C6.1 10 7 10.9 7 12Z"
                      fill="#FFCC00"
                      fill-opacity="0.6"
                    />
                    <path
                      d="M8 18C8 16.34 6.66 15 5 15C3.34 15 2 16.34 2 18H8Z"
                      fill="#FFCC00"
                      fill-opacity="0.6"
                    />
                  </svg>
                </span>
              </div>
              <div class="students-content">
                <span class="students-count">12,000+</span>
                <span class="students-text">satisfied students</span>
              </div>
            </div>
          </div>
        </div>

        <div class="hero-cta">
          <div class="cta-section">
            <button
              class="cta-button primary full-width"
              (click)="redirectToPayment()"
            >
              Order Now – ₹399/- Only
              <span class="button-tagline"
                >VIP Bundle Worth ₹40,195/- Free</span
              >
            </button>
          </div>

          <div class="shipping-info">
            <p>📦 Ships April 25 | Bonuses Unlock May 4, 2025</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="background-elements">
    <div class="circle circle-1"></div>
    <div class="circle circle-2"></div>
    <div class="circle circle-3"></div>
  </div>
</section>

<section class="author-credentials">
  <div class="container">
    <div class="credentials-wrapper">
      <div class="credentials-content">
        <h3 class="section-title">From the soul-led author of:</h3>
        <div class="credentials-list">
          <div class="credential-item">
            <div class="credential-icon-wrapper">
              <span class="credential-icon">📓</span>
              <div class="icon-glow"></div>
            </div>
            <div class="credential-text-container">
              <span class="credential-text">The Mindset Shift Journal</span>
              <span class="credential-subtext">Bestselling guided journal</span>
            </div>
          </div>
          <div class="credential-item">
            <div class="credential-icon-wrapper">
              <span class="credential-icon">🧠</span>
              <div class="icon-glow"></div>
            </div>
            <div class="credential-text-container">
              <span class="credential-text"
                >The Inner Shift Experience course</span
              >
              <span class="credential-subtext"
                >12,000+ graduates worldwide</span
              >
            </div>
          </div>
          <div class="credential-item">
            <div class="credential-icon-wrapper">
              <span class="credential-icon">✨</span>
              <div class="icon-glow"></div>
            </div>
            <div class="credential-text-container">
              <span class="credential-text">The Emotional Reset Protocol™</span>
              <span class="credential-subtext"
                >Transformative healing methodology</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="author-quote-container">
        <div class="quote-decoration">
          <div class="quote-mark">"</div>
          <div class="quote-line"></div>
        </div>
        <div class="quote-content">
          <p class="author-quote">
            This is not just a book. It's a movement to help you heal, align,
            and rise — one small shift at a time.
          </p>
          <div class="quote-attribution-wrapper">
            <p class="quote-attribution">Sharani Ponguru</p>
            <p class="quote-title">Founder, The Mindset Movement</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="credentials-background">
    <div class="accent-shape shape-1"></div>
    <div class="accent-shape shape-2"></div>
  </div>
</section>

<section class="emotional-hook-section" id="emotional-hook">
  <div class="container">
    <h2 class="section-title">
      You don't need to burn out to break through. You just need a shift.
    </h2>

    <div class="hook-content">
      <div class="main-hook">
        <div class="hook-question-container">
          <p class="hook-question">
            What if you could unlock deep inner peace, clear emotional clutter,
            and experience consistent joy...
          </p>
          <div class="question-accent"></div>
        </div>
        <p class="hook-answer">
          …not by doing more, but by aligning with your true self?
        </p>
        <p class="hook-promise">
          Mindset Shift – Small Changes, Big Impact is your practical,
          heart-centered guide to emotional mastery, inner healing, and
          energetic alignment — regardless of your age, past, or pain.
        </p>
      </div>

      <div class="toolkit-section">
        <div class="toolkit-header">
          <h3 class="toolkit-title">This book is your toolkit to:</h3>
          <div class="toolkit-accent"></div>
        </div>
        <ul class="toolkit-list">
          <li class="toolkit-item">
            <div class="toolkit-icon-wrapper">
              <div class="toolkit-icon">✨</div>
              <div class="icon-glow"></div>
            </div>
            <div class="toolkit-text">
              Shift your energy without toxic positivity
            </div>
          </li>
          <li class="toolkit-item">
            <div class="toolkit-icon-wrapper">
              <div class="toolkit-icon">🧠</div>
              <div class="icon-glow"></div>
            </div>
            <div class="toolkit-text">
              Rewire limiting beliefs without shame
            </div>
          </li>
          <li class="toolkit-item">
            <div class="toolkit-icon-wrapper">
              <div class="toolkit-icon">🎯</div>
              <div class="icon-glow"></div>
            </div>
            <div class="toolkit-text">
              Discover intentions that outlive outdated goals
            </div>
          </li>
          <li class="toolkit-item">
            <div class="toolkit-icon-wrapper">
              <div class="toolkit-icon">⚡</div>
              <div class="icon-glow"></div>
            </div>
            <div class="toolkit-text">
              Reclaim your power with grace, not pressure
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="hook-background-elements">
    <div class="accent-circle circle-1"></div>
    <div class="accent-circle circle-2"></div>
    <div class="accent-shape shape-1"></div>
  </div>
</section>

<section class="testimonials-section" id="testimonials">
  <div class="particle"></div>
  <div class="particle"></div>
  <div class="particle"></div>
  <div class="particle"></div>
  <div class="particle"></div>

  <div class="container">
    <div class="section-header">
      <h2 class="section-title">
        Real Testimonials <span class="subtitle">(Early Readers)</span>
      </h2>
      <div class="title-accent"></div>
    </div>

    <div class="testimonials-container">
      <div class="testimonial-card">
        <div class="testimonial-content">
          <div class="quote-mark">"</div>
          <div class="testimonial-glow"></div>
          <p class="testimonial-text">
            Reading this book felt like talking to my future self. It's
            powerful, gentle, and deeply real."
          </p>
          <div class="testimonial-author">
            <div class="author-avatar">
              <span>AT</span>
            </div>
            <div class="author-info">
              <p class="author-name">— Asha T.</p>
              <p class="author-title">Educator & Mother</p>
            </div>
          </div>
          <div class="testimonial-rating">
            <div class="stars">★★★★★</div>
          </div>
        </div>
      </div>

      <div class="testimonial-card featured">
        <div class="featured-badge">Featured</div>
        <div class="testimonial-content">
          <div class="quote-mark">"</div>
          <div class="testimonial-glow"></div>
          <p class="testimonial-text">
            I didn't expect to cry, reflect, and reset my life in one sitting.
            Every woman needs this book."
          </p>
          <div class="testimonial-author">
            <div class="author-avatar">
              <span>RS</span>
            </div>
            <div class="author-info">
              <p class="author-name">— Renu S.</p>
              <p class="author-title">Therapist</p>
            </div>
          </div>
          <div class="testimonial-rating">
            <div class="stars">★★★★★</div>
          </div>
        </div>
      </div>

      <div class="testimonial-card">
        <div class="testimonial-content">
          <div class="quote-mark">"</div>
          <div class="testimonial-glow"></div>
          <p class="testimonial-text">
            Sharani has gifted the world a handbook to the soul. This is far
            more than mindset — it's heartset."
          </p>
          <div class="testimonial-author">
            <div class="author-avatar">
              <span>KM</span>
            </div>
            <div class="author-info">
              <p class="author-name">— Kiran M.</p>
              <p class="author-title">Coach & Speaker</p>
            </div>
          </div>
          <div class="testimonial-rating">
            <div class="stars">★★★★★</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="testimonial-background">
    <div class="bg-shape shape-1"></div>
    <div class="bg-shape shape-2"></div>
    <div class="bg-shape shape-3"></div>
  </div>
</section>

<section class="book-content-section" id="book-content">
  <div class="container">
    <div class="section-header">
      <h2 class="section-title">What You'll Discover Inside the Book</h2>
      <p class="section-intro">
        Inside Mindset Shift – Small Changes, Big Impact, you'll experience:
      </p>
    </div>

    <div class="content-grid">
      <div class="content-row">
        <div class="content-item">
          <div class="content-card">
            <div class="card-accent"></div>
            <h3 class="content-title">Gratitude Hypnosis to Shift Instantly</h3>
            <div class="content-details">
              <ul class="content-benefits">
                <li>
                  Calm your nervous system and anchor yourself in the present
                </li>
                <li>Release mental clutter and emotional overwhelm</li>
                <li>
                  Build emotional resilience, no matter what life throws at you
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="content-item">
          <div class="content-card">
            <div class="card-accent"></div>
            <h3 class="content-title">
              Dream Hypnosis to Awaken the Future You
            </h3>
            <div class="content-details">
              <ul class="content-benefits">
                <li>Visualize your most aligned future in vivid detail</li>
                <li>Reprogram your subconscious to believe in that vision</li>
                <li>
                  Create a magnetic pull toward your goals by feeling them daily
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="content-row">
        <div class="content-item">
          <div class="content-card">
            <div class="card-accent"></div>
            <h3 class="content-title">The Power of WHY, WHAT & HOW</h3>
            <div class="content-details">
              <ul class="content-benefits">
                <li>
                  Get ultra-clear on your purpose (WHY), your destination
                  (WHAT), and your path (HOW)
                </li>
                <li>
                  This 3-step framework keeps you grounded, focused, and aligned
                </li>
                <li>No more wishful thinking—this is strategy for your soul</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="content-item">
          <div class="content-card">
            <div class="card-accent"></div>
            <h3 class="content-title">20-Day Goal Setting Journey</h3>
            <div class="content-details">
              <ul class="content-benefits">
                <li>
                  A structured, step-by-step process to set and achieve one
                  powerful goal in 20 days
                </li>
                <li>
                  You'll learn to move with intention, clarity, and momentum
                </li>
                <li>Realistic. Focused. Game-changing.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="content-row">
        <div class="content-item">
          <div class="content-card">
            <div class="card-accent"></div>
            <h3 class="content-title">
              Reframing Obstacles as Learning Opportunities
            </h3>
            <div class="content-details">
              <ul class="content-benefits">
                <li>
                  Transform how you look at failure, rejection, and delays
                </li>
                <li>Shift from "Why me?" to "What is this teaching me?"</li>
                <li>Build the mindset of resilience and emotional strength</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="content-item">
          <div class="content-card">
            <div class="card-accent"></div>
            <h3 class="content-title">Self-Compassion: Your New Superpower</h3>
            <div class="content-details">
              <ul class="content-benefits">
                <li>Let go of perfectionism and the inner critic</li>
                <li>
                  Learn how to show up for yourself like you do for others
                </li>
                <li>
                  Develop kindness, softness, and inner strength—at the same
                  time
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="content-row">
        <div class="content-item">
          <div class="content-card">
            <div class="card-accent"></div>
            <h3 class="content-title">Accountability That Feels Empowering</h3>
            <div class="content-details">
              <ul class="content-benefits">
                <li>
                  Discover how to choose (and be) an accountability partner who
                  gets it
                </li>
                <li>
                  Learn tools to stay consistent and motivated—without shame or
                  pressure
                </li>
                <li>Because we rise faster together</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="content-item">
          <div class="content-card">
            <div class="card-accent"></div>
            <h3 class="content-title">
              Breakthrough Journaling for Deep Inner Work
            </h3>
            <div class="content-details">
              <ul class="content-benefits">
                <li>
                  Not your typical prompts—these are designed to shake your
                  patterns
                </li>
                <li>
                  Reflect, release, and rewire the stories that have held you
                  back
                </li>
                <li>
                  Access inner clarity, confidence, and courage—one page at a
                  time
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="content-row">
        <div class="content-item">
          <div class="content-card">
            <div class="card-accent"></div>
            <h3 class="content-title">
              Daily Mindset Rituals for Lasting Change
            </h3>
            <div class="content-details">
              <ul class="content-benefits">
                <li>
                  Morning mindset resets, evening reflection routines, and
                  emotional grounding tools
                </li>
                <li>
                  Create daily moments that reconnect you to peace, purpose, and
                  power
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="content-item">
          <div class="content-card">
            <div class="card-accent"></div>
            <h3 class="content-title">
              Real Stories. Real Emotions. Real Shifts.
            </h3>
            <div class="content-details">
              <ul class="content-benefits">
                <li>
                  Includes the unforgettable story of how people burst into
                  tears and found peace during Sharani's live hypnosis session
                </li>
                <li>
                  Even the person managing music slipped into a trance—it was a
                  turning point
                </li>
                <li>
                  These stories show you what's possible because your shift is
                  coming too.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="vip-bundle-section" id="vip-bundle">
  <div class="container-fluid">
    <h2 class="section-title">
      The VIP Bundle <br /><span class="subtitle">(Full Value Breakdown)</span>
    </h2>
    <div class="bundle-intro">When you order today, you'll receive:</div>

    <div class="bundle-grid single-row">
      <div class="bundle-item">
        <div class="item-content">
          <h3 class="item-title">
            Paperback Copy of Mindset Shift
            <span class="item-price">(MRP ₹399)</span>
          </h3>
          <p class="item-description">
            The complete, first-edition hardcopy — delivered to your doorstep.
          </p>
        </div>
      </div>

      <div class="bundle-item">
        <div class="item-content">
          <h3 class="item-title">
            Mindset Shift Mastery Course
            <span class="item-price">(Worth ₹7,399)</span>
          </h3>
          <p class="item-description">
            Step-by-step self-paced video course to implement every chapter into
            your real life.
          </p>
          <p class="item-note">Launches May 4, 2025</p>
        </div>
      </div>

      <div class="bundle-item">
        <div class="item-content">
          <h3 class="item-title">
            The Inner Shift Experience – 30-Min Live Session
            <span class="item-price">(Worth ₹9,999)</span>
          </h3>
          <p class="item-description">
            Live guided session to reset your mindset, release emotional blocks,
            and start fresh.
          </p>
          <p class="item-note">Announced on 3rd Week of May 2025</p>
        </div>
      </div>

      <div class="bundle-item">
        <div class="item-content">
          <h3 class="item-title">
            Weekly LIVE Integration Calls for Life
            <span class="item-price">(Worth ₹7,399)</span>
          </h3>
          <p class="item-description">
            Every Wednesday, join Sharani's team for guided journaling, rituals,
            intention alignment, and healing support — for life.
          </p>
        </div>
      </div>

      <div class="bundle-item">
        <div class="item-content">
          <h3 class="item-title">
            VIP Access to The Mindset Movement Community
            <span class="item-price">(Worth ₹4,999)</span>
          </h3>
          <p class="item-description">
            Your private circle of like-minded souls for support, reflection,
            and accountability.
          </p>
        </div>
      </div>
    </div>
    <div class="bundle-cta">
      <div class="bundle-cta-flex">
        <div class="value-summary-footer">
          <div class="value-badge">
            <div class="badge-content">
              <div class="total-value">Total Value = ₹40,195/-</div>
              <div class="price-divider"></div>
              <div class="your-price">
                Your Price Today:
                <span class="highlight-price">₹399/- Only</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="timeline-section" id="timeline">
  <div class="container">
    <div class="section-header">
      <h2 class="section-title">Your Transformation Journey</h2>
      <p class="timeline-subtitle">From Order to Experience</p>
    </div>

    <div class="timeline-container">
      <div class="timeline-track">
        <div class="timeline-progress"></div>
      </div>

      <div class="timeline-items">
        <div class="timeline-item left">
          <div class="timeline-card">
            <span class="timeline-badge">Step 1</span>
            <h3 class="timeline-title">Book Ships</h3>
            <p class="timeline-date">Starting April 25, 2025</p>
            <p class="timeline-description">
              Your physical copy will be dispatched to your doorstep with
              premium packaging
            </p>
          </div>
        </div>

        <div class="timeline-item right">
          <div class="timeline-card">
            <span class="timeline-badge">Step 2</span>
            <h3 class="timeline-title">All Bonuses Unlock</h3>
            <p class="timeline-date">May 4, 2025</p>
            <p class="timeline-description">
              Access your complete VIP bundle with all digital bonuses worth
              ₹40,195/-
            </p>
          </div>
        </div>

        <div class="timeline-item left">
          <div class="timeline-card">
            <span class="timeline-badge">Instant</span>
            <h3 class="timeline-title">Digital Access</h3>
            <p class="timeline-date">Immediately After Purchase</p>
            <p class="timeline-description">
              Sent via WhatsApp & Email with your order confirmation and welcome
              guide
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="timeline-cta">
      <div class="timeline-guarantee">
        <div class="guarantee-icon">✨</div>
        <p class="guarantee-text">
          Your transformation journey begins the moment you decide
        </p>
      </div>
      <button
        class="cta-button primary pulse-button"
        (click)="redirectToPayment()"
      >
        <span class="button-icon">🔒</span> Secure Your Copy – ₹399/- Only
      </button>
    </div>
  </div>
</section>

<section class="cta-block-section" id="pre-order">
  <div class="container">
    <div class="cta-card">
      <div class="cta-glow"></div>
      <div class="cta-accent-line"></div>

      <h2 class="cta-title">Ready to Shift Your Mindset?</h2>

      <div class="cta-value">
        <div class="total-value">Total Value: ₹40,195/-</div>
        <div class="pre-order-price">
          Order Price Today:
          <span class="highlight-price">₹399/- Only</span>
        </div>
      </div>

      <p class="cta-message">
        Tap Below to Reserve Your Copy & Unlock All Bonuses
      </p>

      <button class="cta-button primary pulse-button" (click)="redirectToPayment()">
        <span class="button-icon">👉</span> Order Now
      </button>

      <div class="guarantee">
        <div class="guarantee-icon">🛡️</div>
        <div class="guarantee-text">
          <p class="guarantee-title">100% Satisfaction Guarantee</p>
          <p class="guarantee-description">
            If you're not completely satisfied with your purchase, we'll make it
            right.
          </p>
        </div>
      </div>

      <div class="cta-particles">
        <div class="particle particle-1"></div>
        <div class="particle particle-2"></div>
        <div class="particle particle-3"></div>
      </div>
    </div>
  </div>
</section>

<section class="bonus-details-section" id="bonus-details">
  <div class="container">
    <h2 class="section-title">Bonus Details – In-Depth</h2>

    <div class="bonuses-container horizontal-bonuses">
      <div class="bonus-card">
        <div class="bonus-header">
          <div class="bonus-number">BONUS 1</div>
          <h3 class="bonus-title">Mindset Shift Mastery Course</h3>
          <div class="bonus-value">[Value: ₹7,399]</div>
        </div>

        <div class="bonus-content">
          <p class="bonus-intro">Learn how to:</p>
          <ul class="bonus-features">
            <li>Apply every shift practically</li>
            <li>Journal with alignment</li>
            <li>Regulate your nervous system</li>
            <li>Stop self-sabotage gently</li>
            <li>Reclaim self-worth through clarity</li>
          </ul>
        </div>
      </div>

      <div class="bonus-card">
        <div class="bonus-header">
          <div class="bonus-number">BONUS 2</div>
          <h3 class="bonus-title">
            The Inner Shift Experience – 30-Min Live Session
          </h3>
          <div class="bonus-value">[Value: ₹7,399]</div>
        </div>

        <div class="bonus-content">
          <p class="bonus-intro">
            Sharani's most powerful live facilitation. Inside, you'll:
          </p>
          <ul class="bonus-features">
            <li>Discover your "Stuck Story"</li>
            <li>Reset emotional energy in real time</li>
            <li>Get group breakthroughs through shared healing</li>
            <li>Integrate inner peace rituals for lasting transformation</li>
          </ul>
        </div>
      </div>

      <div class="bonus-card">
        <div class="bonus-header">
          <div class="bonus-number">BONUS 3</div>
          <h3 class="bonus-title">Weekly LIVE Integration Calls – For Life</h3>
          <div class="bonus-value">[Value: ₹19,999+]</div>
        </div>

        <div class="bonus-content">
          <p class="bonus-intro">
            This isn't a one-time event. Every Wednesday, you'll experience:
          </p>
          <ul class="bonus-features">
            <li>Intention-setting sessions</li>
            <li>Energetic check-ins</li>
            <li>Journaling prompts</li>
            <li>Breathwork for emotional reset</li>
            <li>Live support from Sharani's certified team</li>
          </ul>
        </div>
      </div>

      <div class="bonus-card">
        <div class="bonus-header">
          <div class="bonus-number">BONUS 4</div>
          <h3 class="bonus-title">
            VIP Access to The Mindset Movement Community
          </h3>
          <div class="bonus-value">[Value: ₹4,999]</div>
        </div>

        <div class="bonus-content">
          <p class="bonus-intro">
            Private, heart-centered community on Telegram/WhatsApp/Portal. Get:
          </p>
          <ul class="bonus-features">
            <li>Peer support</li>
            <li>Accountability</li>
            <li>Growth check-ins</li>
            <li>Mini-missions and celebrations</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="author-story-section" id="author-story">
  <div class="container-fluid">
    <div class="author-story-wrapper">
      <div class="section-header">
        <h2 class="section-title">
          Sharani Ponguru's Story
          <span class="subtitle">(About the Author)</span>
        </h2>
      </div>

      <div class="author-story-container">
        <div class="author-image-container">
          <div class="author-image-wrapper">
            <div class="author-image-placeholder">
              <img
                [src]="homePageVideoImage.title"
                alt="Sharani Ponguru"
                class="author-photo"
              />
              <div *ngIf="!homePageVideoImage" class="author-initials">SP</div>
            </div>
            <div class="author-image-glow"></div>
          </div>
          
          <div class="author-quote">
            <div class="quote-mark">"</div>
            <p class="quote-text">
              If you're carrying pain but smiling anyway… this book is for you.
            </p>
          </div>
          
          <div class="author-social">
            <a href="https://www.instagram.com/sharaninarayanaofficial/" class="social-link" target="_blank"
              ><i class="fab fa-instagram"></i> Instagram</a
            >
            <a href="https://www.linkedin.com/in/sharaninarayanaofficial/" class="social-link" target="_blank"
              ><i class="fab fa-linkedin"></i> LinkedIn</a
            >
            <a href="https://sharaniponguru.me/home" class="social-link" target="_blank"
              ><i class="fas fa-globe"></i> Website</a
            >
          </div>
        </div>

        <div class="author-bio">
          <p class="bio-paragraph highlight">
            Sharani Ponguru is not just a coach, not just a healer.
          </p>

          <p class="bio-paragraph">
            She's a gentle but fierce woman who turned her own breakdowns into
            breakthroughs — and has now helped thousands do the same.
          </p>

          <p class="bio-paragraph">
            After years of silently suffering behind success, Sharani broke free
            from internal trauma cycles, perfectionism, and burnout. Her journey
            led her to discover the power of mindset shifts rooted in inner
            child healing, spiritual alignment, and daily emotional rituals.
          </p>

          <p class="bio-paragraph">
            She is now the visionary behind The Mindset Movement — an initiative
            to help people move from survival to soulful living.
          </p>

          <div class="author-achievements">
            <div class="achievement-item">
              <div class="achievement-icon">🌟</div>
              <div class="achievement-text">Certified Mindset Coach</div>
            </div>
            <div class="achievement-item">
              <div class="achievement-icon">📚</div>
              <div class="achievement-text">Bestselling Author</div>
            </div>
            <div class="achievement-item">
              <div class="achievement-icon">👥</div>
              <div class="achievement-text">10,000+ Lives Transformed</div>
            </div>
          </div>

          <div class="author-cta">
            <button
              class="cta-button primary pulse-button"
              (click)="redirectToPayment()"
            >
              <span class="button-icon">📖</span> Order Sharani's Book Now
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="final-cta-section" id="final-cta">
  <div class="container">
    <div class="final-cta-content">
      <div class="cta-left-column">
        <h2 class="cta-headline">
          This book is a mirror. A reset. A friend. A guide.
        </h2>
        <p class="cta-subheadline">
          If your soul has been whispering, this is your sign to answer.
        </p>
      </div>

      <div class="cta-right-column">
        <h3 class="cta-offer">Order Mindset Shift now</h3>
        <p class="cta-value">
          Get ₹40,195 worth of transformation for just ₹399/- only
        </p>
        <p class="cta-dates">
          Book Ships: April 25 | Bonuses Unlock: May 4, 2025
        </p>

        <button class="cta-button primary" (click)="redirectToPayment()">
          <span class="button-icon">👉</span> Claim My Book + VIP Access Now
        </button>
      </div>
    </div>
  </div>
</section>

<section class="faq-section" id="faqs">
  <div class="container">
    <h2 class="section-title">FAQs</h2>

    <div class="faq-wrapper">
      <div class="faq-column">
        <div
          class="faq-item"
          [class.active]="faqStates[0]"
          (click)="toggleFaq(0)"
        >
          <div class="faq-header">
            <h3>1. What will I receive?</h3>
            <div class="icon">
              <span>+</span>
            </div>
          </div>
          <div class="faq-body">
            <p>You'll receive:</p>
            <ul>
              <li>A hard copy of the book</li>
              <li>Mindset Shift Mastery Course</li>
              <li>Inner Shift Experience live session</li>
              <li>Weekly integration calls</li>
              <li>VIP Community Membership</li>
            </ul>
            <p><strong>Total Value: ₹40,195/-</strong></p>
          </div>
        </div>

        <div
          class="faq-item"
          [class.active]="faqStates[1]"
          (click)="toggleFaq(1)"
        >
          <div class="faq-header">
            <h3>2. When will I receive the book?</h3>
            <div class="icon">
              <span>+</span>
            </div>
          </div>
          <div class="faq-body">
            <p>
              Books ship from April 25, 2025. You'll receive tracking details
              via WhatsApp or Email.
            </p>
          </div>
        </div>

        <div
          class="faq-item"
          [class.active]="faqStates[2]"
          (click)="toggleFaq(2)"
        >
          <div class="faq-header">
            <h3>3. When do I get digital bonuses?</h3>
            <div class="icon">
              <span>+</span>
            </div>
          </div>
          <div class="faq-body">
            <p>
              All digital bonuses unlock on May 4th, 2025, including the course,
              live session invite, and community access.
            </p>
          </div>
        </div>

        <div
          class="faq-item"
          [class.active]="faqStates[3]"
          (click)="toggleFaq(3)"
        >
          <div class="faq-header">
            <h3>4. Digital or physical book?</h3>
            <div class="icon">
              <span>+</span>
            </div>
          </div>
          <div class="faq-body">
            <p>
              Physical paperback delivered to your doorstep, plus bonus digital
              journal prompts.
            </p>
          </div>
        </div>

        <div
          class="faq-item"
          [class.active]="faqStates[4]"
          (click)="toggleFaq(4)"
        >
          <div class="faq-header">
            <h3>5. Is this offer worth ₹40,135+?</h3>
            <div class="icon">
              <span>+</span>
            </div>
          </div>
          <div class="faq-body">
            <p>
              Yes. This transformation bundle includes the book (₹399), course
              (₹7,399), live session (₹9,999), weekly calls (₹7,399), and VIP
              membership (₹4,999).
            </p>
          </div>
        </div>
      </div>

      <div class="faq-column">
        <div
          class="faq-item"
          [class.active]="faqStates[5]"
          (click)="toggleFaq(5)"
        >
          <div class="faq-header">
            <h3>6. Miss the May 4th live session?</h3>
            <div class="icon">
              <span>+</span>
            </div>
          </div>
          <div class="faq-body">
            <p>
              You'll get full replay access, lifetime access to the reset
              ritual, and invites to future sessions.
            </p>
          </div>
        </div>

        <div
          class="faq-item"
          [class.active]="faqStates[6]"
          (click)="toggleFaq(6)"
        >
          <div class="faq-header">
            <h3>7. Outside India?</h3>
            <div class="icon">
              <span>+</span>
            </div>
          </div>
          <div class="faq-body">
            <p>
              Currently for India only. Available on Amazon.us from April 15th
              onward.
            </p>
          </div>
        </div>

        <div
          class="faq-item"
          [class.active]="faqStates[7]"
          (click)="toggleFaq(7)"
        >
          <div class="faq-header">
            <h3>8. Who is this book for?</h3>
            <div class="icon">
              <span>+</span>
            </div>
          </div>
          <div class="faq-body">
            <p>
              Anyone feeling stuck, overwhelmed, or disconnected - from students
              to professionals, parents to soul-seekers.
            </p>
          </div>
        </div>

        <div
          class="faq-item"
          [class.active]="faqStates[8]"
          (click)="toggleFaq(8)"
        >
          <div class="faq-header">
            <h3>9. Will I join a community?</h3>
            <div class="icon">
              <span>+</span>
            </div>
          </div>
          <div class="faq-body">
            <p>
              Yes! You'll get lifetime access to The Mindset Movement VIP
              community with support, inspiration, and live call reminders.
            </p>
          </div>
        </div>

        <div
          class="faq-item"
          [class.active]="faqStates[9]"
          (click)="toggleFaq(9)"
        >
          <div class="faq-header">
            <h3>10. Is this offer limited?</h3>
            <div class="icon">
              <span>+</span>
            </div>
          </div>
          <div class="faq-body">
            <p>
              YES. This ₹399 bundle is only for the first edition pre-order
              batch. After this, components will be sold separately at much
              higher prices.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="faq-cta">
      <div class="cta-card primary-card" (click)="redirectToPayment()">
        <div class="cta-content">
          <p class="cta-message">So, if you're feeling called, don't wait.</p>
          <p class="cta-highlight">
            This is your one chance to get it all for just ₹399.
          </p>
          <button class="cta-button dark">Order Now – ₹399/- Only</button>
        </div>
        <div class="cta-shine"></div>
      </div>
    </div>
  </div>
</section>

<app-exam-footer></app-exam-footer>
